import { AxiosResponse } from "axios";
import {
  GetMealRecipeDetailsApiRequest,
  GetMealRecipeDetailsApiResponse,
  GetCustomMealByIdApiResponse,
  GetCustomMealMealTypeSectionsApiRequest,
  GetCustomMealMealTypeSectionsApiResponse,
  GetCustomMealMealTypeSectionIngredientsApiResponse,
  PostCustomMealMealTypeSectionIngredientApiResponse,
  PutCustomMealMealTypeSectionIngredientApiResponse,
  UpsertCustomMealMealTypeSectionIngredientPayload,
  GetAssignedMealTypesByMealIdApiRequest,
  GetCustomMealsApiResponse,
  GetCustomMealMealTypesApiResponse,
  GetCustomMealTypeByIdApiResponse,
  GetCustomMealTypesApiResponse,
  GetIngredientClassificationByIdApiResponse,
  GetIngredientClassificationsApiResponse,
  PostAssignMealTypesToMealsApiRequest,
  PostCustomMealMealTypeSectionApiRequest,
  PostCustomMealMealTypeSectionApiResponse,
  PostCustomMealApiResponse,
  PutMealSyncApiRequest,
  PutMealSyncApiResponse,
  PostCustomMealMealTypeApiResponse,
  PostIngredientClassificationApiResponse,
  PostCustomMealTypeApiResponse,
  PutAssignMealTypesToMealsApiRequest,
  PutCustomMealMealTypeSectionApiRequest,
  PutCustomMealMealTypeSectionApiResponse,
  PutCustomMealApiResponse,
  PutCustomMealMealTypeApiResponse,
  PutIngredientClassificationApiResponse,
  PutCustomMealTypeApiResponse,
  UpsertCustomMealPayload,
  UpsertIngredientClassificationPayload,
  UpsertCustomMealTypePayload,
  GetIngredientsApiResponse,
  GetIngredientByIdApiResponse,
  PostIngredientApiResponse,
  PutIngredientApiResponse,
  UpsertIngredientPayload,
} from "app/types/custom-meals";
import axios from "./config";

export const getCustomMealTypesApi = (
  storeId: number,
  query = "",
): Promise<AxiosResponse<GetCustomMealTypesApiResponse>> =>
  axios.get<GetCustomMealTypesApiResponse>(
    `/stores/${storeId}/meal-types${query}`,
  );

export const getCustomMealTypeByIdApi = (
  storeId: number,
  mealTypeId: number,
): Promise<AxiosResponse<GetCustomMealTypeByIdApiResponse>> =>
  axios.get<GetCustomMealTypeByIdApiResponse>(
    `/stores/${storeId}/meal-types/${mealTypeId}`,
  );

type PostCustomMealTypeApiRequest = {
  storeId: number;
  payload: UpsertCustomMealTypePayload;
};

export const postCustomMealTypeApi = ({
  storeId,
  payload,
}: PostCustomMealTypeApiRequest): Promise<
  AxiosResponse<PostCustomMealTypeApiResponse>
> =>
  axios.post<PostCustomMealTypeApiResponse>(
    `/stores/${storeId}/meal-types`,
    payload,
  );

type PutCustomMealTypeApiRequest = {
  storeId: number;
  mealTypeId: number;
  payload: UpsertCustomMealTypePayload;
};

export const putCustomMealTypeApi = ({
  storeId,
  mealTypeId,
  payload,
}: PutCustomMealTypeApiRequest): Promise<
  AxiosResponse<PutCustomMealTypeApiResponse>
> =>
  axios.put<PutCustomMealTypeApiResponse>(
    `/stores/${storeId}/meal-types/${mealTypeId}`,
    payload,
  );

export const getIngredientClassificationsApi = (
  storeId: number,
  query = "",
): Promise<AxiosResponse<GetIngredientClassificationsApiResponse>> =>
  axios.get<GetIngredientClassificationsApiResponse>(
    `/stores/${storeId}/ingredient-classifications${query}`,
  );

export const getIngredientClassificationByIdApi = (
  storeId: number,
  ingredientClassificationId: number,
): Promise<AxiosResponse<GetIngredientClassificationByIdApiResponse>> =>
  axios.get<GetIngredientClassificationByIdApiResponse>(
    `/stores/${storeId}/ingredient-classifications/${ingredientClassificationId}`,
  );

type PostIngredientClassificationApiRequest = {
  storeId: number;
  payload: UpsertIngredientClassificationPayload;
};

export const postIngredientClassificationApi = ({
  storeId,
  payload,
}: PostIngredientClassificationApiRequest): Promise<
  AxiosResponse<PostIngredientClassificationApiResponse>
> =>
  axios.post<PostIngredientClassificationApiResponse>(
    `/stores/${storeId}/ingredient-classifications`,
    payload,
  );

type PutIngredientClassificationApiRequest = {
  storeId: number;
  ingredientClassificationId: number;
  payload: UpsertIngredientClassificationPayload;
};

export const putIngredientClassificationApi = ({
  storeId,
  ingredientClassificationId,
  payload,
}: PutIngredientClassificationApiRequest): Promise<
  AxiosResponse<PutIngredientClassificationApiResponse>
> =>
  axios.put<PutIngredientClassificationApiResponse>(
    `/stores/${storeId}/ingredient-classifications/${ingredientClassificationId}`,
    payload,
  );

export const getCustomMealsApi = (
  storeId: number,
  query = "",
): Promise<AxiosResponse<GetCustomMealsApiResponse>> =>
  axios.get<GetCustomMealsApiResponse>(`/stores/${storeId}/meals${query}`);

export const getCustomMealByIdApi = (
  storeId: number,
  customMealId: number,
): Promise<AxiosResponse<GetCustomMealByIdApiResponse>> =>
  axios.get<GetCustomMealByIdApiResponse>(`/stores/${storeId}/meals/${customMealId}`);

type PostCustomMealApiRequest = {
  storeId: number;
  payload: UpsertCustomMealPayload;
};

export const postCustomMealApi = ({
  storeId,
  payload,
}: PostCustomMealApiRequest): Promise<
  AxiosResponse<PostCustomMealApiResponse>
> =>
  axios.post<PostCustomMealApiResponse>(`/stores/${storeId}/meals`, payload);

type PutCustomMealApiRequest = {
  storeId: number;
  customMealId: number;
  payload: UpsertCustomMealPayload;
};

export const putCustomMealApi = ({
  storeId,
  customMealId,
  payload,
}: PutCustomMealApiRequest): Promise<AxiosResponse<PutCustomMealApiResponse>> =>
  axios.put<PutCustomMealApiResponse>(
    `/stores/${storeId}/meals/${customMealId}`,
    payload,
  );

export const postAssignMealTypesToMeals = ({
  storeId,
  customMealId,
  payload,
}: PostAssignMealTypesToMealsApiRequest): Promise<
  AxiosResponse<PostCustomMealMealTypeApiResponse>
> =>
  axios.post<PostCustomMealMealTypeApiResponse>(
    `/stores/${storeId}/meals/${customMealId}/meal-types`,
    payload,
  );

export const putAssignMealTypesToMeals = ({
  storeId,
  customMealId,
  assignmentId,
  payload,
}: PutAssignMealTypesToMealsApiRequest): Promise<
  AxiosResponse<PutCustomMealMealTypeApiResponse>
> =>
  axios.put<PutCustomMealMealTypeApiResponse>(
    `/stores/${storeId}/meals/${customMealId}/meal-types/${assignmentId}`,
    payload,
  );

export const getAssignedMealTypesByMealId = ({
  storeId,
  customMealId,
}: GetAssignedMealTypesByMealIdApiRequest): Promise<
  AxiosResponse<GetCustomMealMealTypesApiResponse>
> =>
  axios.get<GetCustomMealMealTypesApiResponse>(
    `/stores/${storeId}/meals/${customMealId}/meal-types`,
  );

export const postCustomMealMealTypeSectionApi = ({
  storeId,
  customMealId,
  customMealTypeId,
  payload,
}: PostCustomMealMealTypeSectionApiRequest): Promise<
  AxiosResponse<PostCustomMealMealTypeSectionApiResponse>
> =>
  axios.post<PostCustomMealMealTypeSectionApiResponse>(
    `/stores/${storeId}/meals/${customMealId}/meal-types/${customMealTypeId}/sections`,
    payload,
  );

export const putCustomMealMealTypeSectionApi = ({
  storeId,
  customMealId,
  customMealTypeId,
  sectionId,
  payload,
}: PutCustomMealMealTypeSectionApiRequest): Promise<
  AxiosResponse<PutCustomMealMealTypeSectionApiResponse>
> =>
  axios.put<PutCustomMealMealTypeSectionApiResponse>(
    `/stores/${storeId}/meals/${customMealId}/meal-types/${customMealTypeId}/sections/${sectionId}`,
    payload,
  );

export const getCustomMealMealTypeSectionsApi = ({
  storeId,
  customMealId,
  customMealTypeId,
}: GetCustomMealMealTypeSectionsApiRequest): Promise<
  AxiosResponse<GetCustomMealMealTypeSectionsApiResponse>
> =>
  axios.get<GetCustomMealMealTypeSectionsApiResponse>(
    `/stores/${storeId}/meals/${customMealId}/meal-types/${customMealTypeId}/sections`,
  );

type GetCustomMealMealTypeSectionIngredientsApiRequest = {
  storeId: number;
  customMealId: number;
  customMealTypeId: number;
  sectionId: number;
  query?: string;
};

export const getCustomMealMealTypeSectionIngredientsApi = ({
  storeId,
  customMealId,
  customMealTypeId,
  sectionId,
  query = "",
}: GetCustomMealMealTypeSectionIngredientsApiRequest): Promise<
  AxiosResponse<GetCustomMealMealTypeSectionIngredientsApiResponse>
> =>
  axios.get<GetCustomMealMealTypeSectionIngredientsApiResponse>(
    `/stores/${storeId}/meals/${customMealId}/meal-types/${customMealTypeId}/sections/${sectionId}/ingredients${query}`,
  );

type PostCustomMealMealTypeSectionIngredientApiRequest = {
  storeId: number;
  customMealId: number;
  customMealTypeId: number;
  sectionId: number;
  payload: UpsertCustomMealMealTypeSectionIngredientPayload;
};

export const postCustomMealMealTypeSectionIngredientApi = ({
  storeId,
  customMealId,
  customMealTypeId,
  sectionId,
  payload,
}: PostCustomMealMealTypeSectionIngredientApiRequest): Promise<
  AxiosResponse<PostCustomMealMealTypeSectionIngredientApiResponse>
> =>
  axios.post<PostCustomMealMealTypeSectionIngredientApiResponse>(
    `/stores/${storeId}/meals/${customMealId}/meal-types/${customMealTypeId}/sections/${sectionId}/ingredients`,
    payload,
  );

type PutCustomMealMealTypeSectionIngredientApiRequest = {
  storeId: number;
  customMealId: number;
  customMealTypeId: number;
  sectionId: number;
  assignmentId: number;
  payload: UpsertCustomMealMealTypeSectionIngredientPayload;
};

export const putCustomMealMealTypeSectionIngredientApi = ({
  storeId,
  customMealId,
  customMealTypeId,
  sectionId,
  assignmentId,
  payload,
}: PutCustomMealMealTypeSectionIngredientApiRequest): Promise<
  AxiosResponse<PutCustomMealMealTypeSectionIngredientApiResponse>
> =>
  axios.put<PutCustomMealMealTypeSectionIngredientApiResponse>(
    `/stores/${storeId}/meals/${customMealId}/meal-types/${customMealTypeId}/sections/${sectionId}/ingredients/${assignmentId}`,
    payload,
  );

export const getMealRecipeDetailsApi = ({
  storeId,
  mealId,
  recipeId,
}: GetMealRecipeDetailsApiRequest): Promise<
  AxiosResponse<GetMealRecipeDetailsApiResponse>
> =>
  axios.get<GetMealRecipeDetailsApiResponse>(
    `/stores/${storeId}/meals/${mealId}/recipes/${recipeId}`,
  );

export const putMealSyncApi = ({
  storeId,
  mealId,
}: PutMealSyncApiRequest): Promise<AxiosResponse<PutMealSyncApiResponse>> =>
  axios.put<PutMealSyncApiResponse>(`/stores/${storeId}/meals/${mealId}/sync`, {});

export const getIngredientsApi = (
  storeId: number,
  query = "",
): Promise<AxiosResponse<GetIngredientsApiResponse>> =>
  axios.get<GetIngredientsApiResponse>(
    `/stores/${storeId}/ingredients${query}`,
  );

export const getIngredientByIdApi = (
  storeId: number,
  ingredientId: number,
): Promise<AxiosResponse<GetIngredientByIdApiResponse>> =>
  axios.get<GetIngredientByIdApiResponse>(
    `/stores/${storeId}/ingredients/${ingredientId}`,
  );

type PostIngredientApiRequest = {
  storeId: number;
  payload: UpsertIngredientPayload;
};

export const postIngredientApi = ({
  storeId,
  payload,
}: PostIngredientApiRequest): Promise<
  AxiosResponse<PostIngredientApiResponse>
> =>
  axios.post<PostIngredientApiResponse>(
    `/stores/${storeId}/ingredients`,
    payload,
  );

type PutIngredientApiRequest = {
  storeId: number;
  ingredientId: number;
  payload: UpsertIngredientPayload;
};

export const putIngredientApi = ({
  storeId,
  ingredientId,
  payload,
}: PutIngredientApiRequest): Promise<
  AxiosResponse<PutIngredientApiResponse>
> =>
  axios.put<PutIngredientApiResponse>(
    `/stores/${storeId}/ingredients/${ingredientId}`,
    payload,
  );

